<template>
  <div>
    <load
      v-if="loading_search"
      class="my-3 py-3"
      mode="table"
      :message="`Buscando por <span class='highlightText'>${search}</span>`"
    />
    <div v-else class="col-12 card px-0">
      <!-- <loading-animation
                :active.sync="loading"
                :is-full-page="false"
                :opacity="1"
                color="#5895ff"
            /> -->
      <div class="card-body px-0 py-4">
        <b-table
          :fields="[
            {
              key: 'nome_completo',
              label: $t('Nome'),
            },
            {
              key: 'nome_social',
              label: $t('Nome Social'),
            },
            {
              key: 'cpf',
              label: $t('CPF'),
            },
            {
              key: 'data_nascimento',
              label: $t('Nascimento'),
            },
            {
              key: 'mae',
              label: $t('Filiação 1'),
            },
            {
              key: 'estado_cadastral',
            },
            {
              key: 'atualizacao_cadunico',
              label: $t('Atualização CADUNICO'),
            },
            {
              key: 'atualizacao',
              label: $t('Ultima atualização'),
            },
            {
              key: 'actions',
              label: '',
              class: 'text-right',
              thStyle: { width: '95px', minWidth: '95px' },
            },
          ]"
          :items="familiasList"
          striped
          hover
          show-empty
          small
          outlined
          stacked="md"
          table-class="mb-3"
        >
          <template v-slot:cell(nome_completo)="data">
            <strong>
              <span
                v-if="!data.item.nome_social"
                v-html="
                  $options.filters.highlight(
                    data.item.nome_completo,
                    search.trim()
                  )
                "
              ></span>
              <span class="text-center" v-else>-</span>
            </strong>
          </template>
          <template v-slot:cell(nome_social)="data">
            <strong v-if="data.item.nome_social">
              <span
                v-html="
                  $options.filters.highlight(
                    data.item.nome_social,
                    search.trim()
                  )
                "
              ></span>
            </strong>
          </template>
          <template v-slot:cell(cpf)="data">
            <strong>
              <span
                v-if="data.item.documento"
                v-html="
                  $options.filters.highlight(
                    data.item.documento.cpf,
                    search.trim()
                  )
                "
              ></span
            ></strong>
          </template>
          <template v-slot:cell(data_nascimento)="data">
            <strong> {{ data.item.data_nascimento }}</strong>
          </template>

          <template v-slot:cell(mae)="data">
            <strong>
              <span
                v-html="
                  $options.filters.highlight(data.item.mae, search.trim())
                "
              ></span
            ></strong>
          </template>
          <template v-slot:cell(estado_cadastral)="data">
            <span class="small" v-html="data.item.estado_cadastral"></span>
          </template>
          <template v-slot:cell(atualizacao_cadunico)="data">
            <strong> {{ data.item.atualizacao_cadunico }}</strong>
          </template>
          <template v-slot:cell(atualizacao)="data">
            <strong> {{ data.item.atualizacao }}</strong>
          </template>
          <template v-slot:cell()="data">
            <b-button
              :title="$t('Editar Família')"
              @click="edit(data.item.familia_id)"
              :class="
                data.item.familia.estado_cadastral == 4 &&
                data.item.familia.estado_cadastral == 5
                  ? 'px-2 mb-0'
                  : 'px-2 m-0'
              "
              size="sm"
              type="button"
              v-b-tooltip.hover
              variant="success"
            >
              <i class="fas fa-edit"></i>
            </b-button>

            <!--
            Regra temporariamente desativada:
            v-if="
              data.item.estado_cadastral_id != 4 &&
              data.item.estado_cadastral_id != 5
            "
            -->

            <b-dropdown
              no-caret
              variant="info"
              size="sm"
              v-b-tooltip.hover
              right
              title="Serviços/Intervenções"
            >
              <template #button-content>
                <i class="fas fa-ellipsis-v"></i>
              </template>
              <b-dropdown-group id="dropdown-group-1" header="Intervenções">
                <b-dropdown-item
                  @click="openAtendimentos(data.item.familia_id)"
                >
                  Atendimentos
                </b-dropdown-item>
                <template v-if="$store.state.user.role_details.name != 'Nível Básico'">
                  <b-dropdown-item
                    @click="openEncaminhamentos(data.item.familia_id)"
                  >
                    Encaminhamentos
                  </b-dropdown-item>
                  <b-dropdown-item @click="openReferencias(data.item.familia_id)">
                    Referência e Contrarreferência
                  </b-dropdown-item>
                  <b-dropdown-item @click="openMedidas(data.item.familia_id)">
                    Medidas Socioeducativas
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="openAcompanhamentos(data.item.familia_id)"
                  >
                    Acompanhamentos
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="openViolacaodedireitos(data.item.familia_id)"
                  >
                    Violação de Direitos
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="openAcolhimentos(data.item.familia_id)"
                  >
                    Histórico de Acolhimentos
                  </b-dropdown-item>
                </template>
              </b-dropdown-group>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-group id="dropdown-group-2" header="Serviços" v-if="$store.state.user.role_details.name != 'Nível Básico'">
                <b-dropdown-item @click="openBeneficios(data.item.familia_id)">
                  Benefícios
                </b-dropdown-item>
                <b-dropdown-item
                  @click="openProgramasSociais(data.item.familia_id)"
                >
                  Programas Sociais
                </b-dropdown-item>
              </b-dropdown-group>
            </b-dropdown>
          </template>
          <template v-slot:empty="scope">
            <div class="text-center my-5">
              <img
                :alt="$t('No results')"
                class="mb-5"
                src="/img/icons/robot.svg"
                style="max-height: 165px"
              />
              <h3 class="bold">{{ $t("No records found") }}</h3>
            </div>
          </template>
        </b-table>

        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="perPage"
                v-on:change="
                  $emit('load', page, perPage);
                  loading_search = true;
                "
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="page"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }}
              {{ pagination.currentPage }}
              de
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "search",
    "familiasList",
    "paginationFamilia",
    "submitsearch",
    "loading",
    "filtroFamiliares",
    "pagination",
  ],
  name: "ResultadoBuscarFamilias",
  data() {
    return {
      loading_search: true,
      page: 1,
      perPage: 10,
      // pagination: {
      //     currentPage: 0,
      //     perPage: 0,
      //     total: 0,
      //     totalPages: 0
      // }
    };
  },
  watch: {
    familiasList() {
      this.loading_search = false;
    },
  },
  methods: {
    edit(id) {
      this.redirect(`/dashboard/familias/edit/${id}`);
    },
    openAtendimentos(id) {
      this.redirect(`/dashboard/atendimentos/${id}`);
    },
    openEncaminhamentos(id) {
      this.redirect(`/dashboard/encaminhamentos/${id}?familia_id=${id}`);
    },
    openReferencias(id) {
      this.redirect(`/dashboard/referenciamentos/${id}?familia_id=${id}`);
    },
    openMedidas(id) {
      this.redirect(`/dashboard/medidas/${id}?familia_id=${id}`);
    },
    openAcompanhamentos(id) {
      this.redirect(`/dashboard/acompanhamentos/${id}?familia_id=${id}`);
    },
    openViolacaodedireitos(id) {
      this.redirect(`/dashboard/violacaodedireitos/${id}?familia_id=${id}`);
    },
    openAcolhimentos(id) {
      this.redirect(`/dashboard/acolhimentos/${id}?familia_id=${id}`);
    },
    openBeneficios(id) {
      this.redirect(`/dashboard/familia/beneficios/${id}?familia_id=${id}`);
    },
    openProgramasSociais(id) {
      this.redirect(
        `/dashboard/programassociais/beneficiarios/${id}?familia_id=${id}`
      );
    },
    redirect(url) {
      swal.fire({
        title: "Aguarde",
        text: "Redirecionando para a familia.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      this.$emit("close");
      window.location = url;
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.$emit("load", this.page, this.perPage);
        this.loading_search = true;
      }
    },
  },
};
</script>

<style>
.highlightText {
  background: yellow;
}
</style>
